export const baseUrl = "https://atci.lkm.accenture.com/lttmicrosite-apis";

export const baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3046"
    : window.location.href.split(".")[3] === "staging"
    ? "https://atci.lkm.ind.staging.accenture.com/indstaging-apis"
    : "https://atci.lkm.ind.accenture.com/ind-apis";

    console.log(process.env.NODE_ENV,"environment")

